import { Box, Chip, Sheet, Stack, Tooltip, Typography } from '@mui/joy';
import ArrowUpwardRoundedIcon from '@mui/icons-material/ArrowUpwardRounded';
import ArrowDownwardRoundedIcon from '@mui/icons-material/ArrowDownwardRounded';


/**
 * Карточка метрики со сравнением с предыдущим периодом.
 *
 * Дельта может прийти null — это значит, что в прошлом периоде был ноль
 * и считать процент роста бессмысленно. Рисуем прочерк, а не «+100%»
 * и тем более не «+∞».
 *
 * inverted нужен для метрик, где рост это плохо: цена клика выросла —
 * стрелка должна быть красной, а не зелёной.
 */
export default function AdMetricCard({
    label, value, delta, hint, inverted = false, size = 'md',
}) {
    const hasDelta = delta !== null && delta !== undefined && Number.isFinite(Number(delta));
    const numeric = Number(delta);
    const positive = numeric > 0;
    const good = inverted ? !positive : positive;

    return (
        <Sheet variant="soft" sx={{ p: 2, borderRadius: 'md', flex: 1, minWidth: 150 }}>
            <Typography level="body-xs" color="neutral">{label}</Typography>
            <Stack direction="row" spacing={1} alignItems="baseline" sx={{ mt: 0.3 }}>
                <Typography
                    level={size === 'lg' ? 'h3' : 'title-lg'}
                    sx={{ fontWeight: 700 }}
                >
                    {value}
                </Typography>

                {hasDelta && numeric !== 0 && (
                    <Chip
                        size="sm"
                        variant="soft"
                        color={good ? 'success' : 'danger'}
                        startDecorator={positive
                            ? <ArrowUpwardRoundedIcon sx={{ fontSize: 12 }} />
                            : <ArrowDownwardRoundedIcon sx={{ fontSize: 12 }} />}
                    >
                        {Math.abs(numeric).toFixed(1)}%
                    </Chip>
                )}

                {!hasDelta && (
                    <Tooltip arrow variant="soft" title="В прошлом периоде данных не было">
                        <Typography level="body-xs" color="neutral">—</Typography>
                    </Tooltip>
                )}
            </Stack>
            {hint && (
                <Typography level="body-xs" color="neutral" sx={{ mt: 0.2 }}>{hint}</Typography>
            )}
        </Sheet>
    );
}